import sensorDataConfigApi from '@/api/config/sensorDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types'
import { Sensor } from '@/types/sensor'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchSensor(
  searchParams: SearchParams = {},
  interfaceId: number,
): UseQueryResult<APIResponseList<Sensor>, any> {
  return useQuery(
    [queryKeys.sensor, interfaceId, searchParams],

    async () => {
      if (!interfaceId) return null

      const { data } = await sensorDataConfigApi.getAll({
        interfaceId,
        ...searchParams,
      })
      if (!data) return null

      const sensorList =
        data.data.length > 0 &&
        data?.data.map((item: Sensor) => {
          return {
            weatherLinkStationId: item.weatherLinkStationId,
            name: item.name,
            category: item.category,
            sensorSource: item.sensorSource,
          }
        })
      return {
        list: sensorList,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
  )
}

export default useSearchSensor
